import proposal1 from "../assets/images/logo-proposals/ek-proposal-1-brackets.svg"
import proposal2 from "../assets/images/logo-proposals/ek-proposal-2-dark-badge.svg"
import proposal3 from "../assets/images/logo-proposals/ek-proposal-3-outline.svg"
import proposal4 from "../assets/images/logo-proposals/ek-proposal-4-hexagon.svg"
import proposal5 from "../assets/images/logo-proposals/ek-proposal-5-wordmark.svg"
import proposal6 from "../assets/images/logo-proposals/ek-proposal-6-monogram.svg"

export type LogoProposal = {
    id: number
    name: string
    description: string
    src: string
    wordmark?: boolean
}

export const siteLogoProposals: LogoProposal[] = [
    {
        id: 1,
        name: "Brackets",
        description: "White circle with code brackets and lowercase ek.",
        src: proposal1,
    },
    {
        id: 2,
        name: "Dark badge",
        description: "Rounded dark tile with uppercase EK and cyan accent bar.",
        src: proposal2,
    },
    {
        id: 3,
        name: "Outline",
        description: "Minimal double-ring outline with serif ek.",
        src: proposal3,
    },
    {
        id: 4,
        name: "Hexagon",
        description: "Hexagonal tech badge with ek monogram and cyan underline.",
        src: proposal4,
    },
    {
        id: 5,
        name: "Wordmark",
        description: "Horizontal engin kaya wordmark with split color treatment.",
        src: proposal5,
        wordmark: true,
    },
    {
        id: 6,
        name: "Monogram",
        description: "Geometric E and K letterforms built from strokes.",
        src: proposal6,
    },
]

/** Change this index (0–5) to preview a different logo in the header. */
export const ACTIVE_LOGO_PROPOSAL_INDEX = 2

export const activeSiteLogoProposal = siteLogoProposals[ACTIVE_LOGO_PROPOSAL_INDEX]
